import { render, staticRenderFns } from "./ReportPurchases.vue?vue&type=template&id=7a129c2c&scoped=true&"
import script from "./ReportPurchases.vue?vue&type=script&lang=js&"
export * from "./ReportPurchases.vue?vue&type=script&lang=js&"
import style0 from "./ReportPurchases.vue?vue&type=style&index=0&id=7a129c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a129c2c",
  null
  
)

export default component.exports